import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ApiService } from './services/api.service';
import { SettingService } from './services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: []
})
export class AppComponent implements OnInit {
  LOGIN: State = State.Login;
  AUTH: State = State.Auth;
  ERROR: State = State.Error;
  PROCESSING: State = State.Processing;

  invalidLogin = false;
  state: State = State.Processing;
  processingText = 'Processing...';
  invalidLoginText: string = 'Invalid login credentials, please try again.';
  errorText = '';
  client_id: string | null = null;
  redirect_uri: string | null = null;
  nonce: string | null = null;
  smeasy_jwt: string | null = null;
  clientDisplayName: string | null = null;
  clientImageUrl: string | null = null;

  form = new FormGroup({});
  model = {
    companyLoginName: '',
    password: '',
    confirmPassword: ''
  };
  fields: FormlyFieldConfig[] = [
    {
      key: 'companyLoginName',
      type: 'input',
      templateOptions: {
        label: 'Company Login Name',
        type: 'text',
        placeholder: '',
        required: true,
      }
    },
    {
      key: 'username',
      type: 'input',
      templateOptions: {
        label: 'Username',
        type: 'text',
        placeholder: '',
        required: true,
      }
    },
    {
      key: 'password',
      type: 'input',
      templateOptions: {
        label: 'Password',
        type: 'password',
        placeholder: '',
        required: true,
      }
    },
  ];

  constructor(private activatedRoute: ActivatedRoute, private api: ApiService, private settings: SettingService) {  }

  async ngOnInit(): Promise<void> {
    this.activatedRoute.queryParams.subscribe(params => this.checkQueryParams(params));
  }

  async getSettings(client_id: string): Promise<boolean> {
    await this.settings.GetSettings(client_id);
    if (this.settings.clientIdIsValid !== true) {
      this.setErrorState(`client_id: <span class="font-bold">${client_id}</span> is not valid. Please reference the SMEasy developer documentation.`);
      return false;
    } else {
      this.clientDisplayName = this.settings.clientDisplayName;
      this.clientImageUrl = this.settings.clientImageUrl;
      return true;
    }
  }

  async login(model: any): Promise<void> {
    try {
      this.setProcessingLoginState();
      let result = await this.api.login(model.companyLoginName, model.username, model.password)
      if (result.access_token) {
        this.smeasy_jwt = result.access_token;
        this.setAuthState();
      }
    }
    catch (ex: any) {
      console.log('error logging in', ex);
      if (ex instanceof HttpErrorResponse) {
        this.setLoginState(true, ex.error.error_description);
      } else {
        this.setErrorState('Unhandled error logging in.');
      }
    }
  }

  setLoginState(invalidLogin: boolean, invalidLoginText: string = 'Invalid login credentials, please try again.') {
    this.invalidLoginText = invalidLoginText;
    this.invalidLogin = invalidLogin;
    this.state = State.Login;
  }

  setProcessingLoginState() {
    this.invalidLogin = false;
    this.processingText = 'Logging you in...';
    this.state = State.Processing
  }

  setInvalidParamsState(msg: string) {
    this.processingText = msg;
    this.state = State.Error;
  }

  setErrorState(msg: string) {
    this.errorText = msg;
    this.state = State.Error;
  }

  setAuthState() {
    this.state = State.Auth;
  }

  async onAllow() {
    try {
      await this.api.authorize(this.client_id!, this.redirect_uri!, this.nonce || '', this.smeasy_jwt!);
    } catch (ex: any) {
      console.log('error authorizing: ', ex);
      if (ex instanceof HttpErrorResponse) {
        this.setErrorState(ex.error);
      } else {
        this.setErrorState('Unhandled error authroizing application.');
      }
    }
  }

  async checkQueryParams(params: Params): Promise<void> {
    this.client_id = params['client_id'];
    this.redirect_uri = params['redirect_uri'];
    this.nonce = params['state'] || '';
    console.log('client_id: ', this.client_id);
    console.log('redirect_uri: ', this.redirect_uri);
    console.log('state: ', this.nonce);
    if (this.client_id && this.redirect_uri) {
      if (await this.getSettings(this.client_id)){
        this.setLoginState(false);
      }
    } else {
      this.setErrorState('Either <span class="font-bold">client_id</span> or <span class="font-bold">redirect_uri</span> are invalid or not provided. Please refer to the SMEasy developer documentation.');
    }
  }
}

export enum State {
  Login = 'LOGIN',
  Auth = 'Auth',
  Processing = 'Processing',
  Error = 'Error'
}
